import React from "react";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import DisplayView from "../../../../components/DisplayView";
import NotInformation from "../../../../components/NotInformation";
import {CustomCardGrid} from "../../../../components/CustomCardGrid";
import {CustomCheckbox} from "../../../../components/CustomCheckbox";
import RowCardText from "../../../../components/RowCardText";
import ButtonActionsCard from "../../../../components/buttons/ButtonActionsCard";
import {ArrowRightIcon} from "../../../../components/buttons/IconButtons";
import IconPersonDefault from "../../../../assets/ImagesDefaults/ic-person-v2.svg";
import {status} from "../../../../enums/statusEnum";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {EMPTY_VALUES} from "../../../../Apis/functions";
import {getViewTypeByName} from "../../../../enums/ViewType";
import GuardRosterCardsApp from "../Functionality/GuardRosterCardsApp";

/**
 * Cards view of the roster of the guards, with the selfie of each guard.
 */
const GuardRosterCards = ({
    selectedList, setSelectedList, modified, setModified, isAllChecked, setIsAllChecked,
    searchElement, setSearchElement, setSearch, setSimpleSearch, setBodyForExport, setCriteria, finalArray,
    option, view, handleView, goUpdate, canUpdate, canDelete, emptyRoster,
}) => {
    const {
        t,
        searchId,
        elementRef,
        results,
        setSearchResults,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
    } = GuardRosterCardsApp({
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setIsAllChecked,
        searchElement,
        setBodyForExport,
        setCriteria,
        finalArray,
        option,
        view,
    });

    return (
        <>
            <div className="d-flex">
                <DisplayView view={view} setView={handleView} left={0}/>
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>

            {results?.content?.length > 0 ?
                <>
                    {canDelete &&
                        <CustomCheckbox
                            id={"cb_gr_all_checked"}
                            trans={'de_/_select_all'}
                            name={"isAllChecked"}
                            checked={isAllChecked}
                            onChange={handleDeleteAll}
                        />
                    }
                    <div className='panelTables' ref={elementRef}>
                        <div className='row'>
                            {results.content.map((item, index) => (
                                <CustomCardGrid
                                    key={item.id}
                                    classNamePanelGrid='col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 px-1 mb-3'
                                    itemId={item.id}
                                    checked={selectedList?.includes(item.id)}
                                    onCheckboxChange={handleCheckboxChange}
                                    disabled={!canDelete}
                                    statusColor={statusColor[item?.statusId]}
                                    statusName={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                                    fontColor={statusFontColor[item?.statusId]}
                                    borderColor={statusBorderColor[item?.statusId]}
                                    chipVariant="large"
                                    srcImage={item?.selfie ? `data:image/png;base64,${item.selfie}` : IconPersonDefault}
                                    backgroundImage={''}
                                    btnActions={
                                        <ButtonActionsCard
                                            id={`btn_gr_card_${canUpdate ? 'update' : 'details'}_${index}`}
                                            name={canUpdate ? 'update' : 'details'}
                                            Icon={ArrowRightIcon}
                                            onClick={() => goUpdate(item)}
                                        />
                                    }
                                >
                                    <div className="px-2">
                                        <RowCardText title={t('name')} value={item?.fullName || EMPTY_VALUES.DEFAULT}/>
                                        <RowCardText title={t('email')} value={item?.email || EMPTY_VALUES.DEFAULT}/>
                                        <RowCardText title={t('phone_number')} value={item?.phoneNumber || EMPTY_VALUES.DEFAULT}/>
                                        <RowCardText title={t('zone_access')} value={item?.zoneAccessName || EMPTY_VALUES.DEFAULT}/>
                                    </div>
                                </CustomCardGrid>
                            ))}
                        </div>
                    </div>
                    {pagination()}
                </>
                :
                <NotInformation card={true} className={"mt-4"}>{emptyRoster}</NotInformation>
            }
        </>
    );
};

export default GuardRosterCards;
